"use strict";

exports.__esModule = true;
exports.logger = void 0;
var logger = console;
exports.logger = logger;


//////////////////
// WEBPACK FOOTER
// ./~/react-query/lib/react/logger.js
// module id = 1940
// module chunks = 0